import React from 'react'
import { Col, Row } from 'reactstrap'

const InfluenzaPossibility = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem right-padding6rem pt-lg-5 pt-md-4 pt-4 pb-lg-4 pb-md-0  pb-4'>
            <Row className='py-md-3'>
                <Col md='12' lg='6' className=''>
                    <div className=''>
                        <div className=''>
                            <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                                Contains COVID-19? Is it Flu? Or Another Possibility?
                            </div>
                            <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>

                        <div className='pt-3'>
                            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black lh-1-6' style={{ letterSpacing:'0.5px'}}>
                            There has never been a greater pressing need to identify respiratory bugs. However, several respiratory illnesses might result in symptoms that overlap. Even during the regular flu season, according to data from United Lab Care Syndromic Trends, influenza accounted for fewer than one-third of all respiratory infections identified during this time. A thorough panel results in fewer missed detections.
                            </div>
                        </div>
                    </div>
                </Col>
                <Col md='12' lg='6' className='pt-md-4 pt-4'>
                    <div className='flex-center'>
                        <img src='influenza-testing/Influenza-Testing-stats3.png' alt='Contains COVID-19' className='img-w5-1' />
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default InfluenzaPossibility